/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/RoomAccomodationReportTable/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import styles from "./index.module.css";

import { useTranslation } from "react-i18next";

const RoomAccomodationReportTable = ({ room }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.usersTableContainer}>
      {/* Desktop/Laptop Table View */}
      <div className={styles.desktopView}>
        <span className={styles.salaNameText}>{room.sala}</span>
        <table className={styles.roomTable}>
          <thead>
            <tr>
              <th className={styles.tableNameHeader}>
                {t("pages.reports.table")}
              </th>
              <th className={styles.companyNameHeader}>
                {t("pages.reports.company")}
              </th>
              <th className={styles.spacesHeader}>
                {t("pages.reports.spaces")}
              </th>
              <th className={styles.scheduleHeader}>
                {t("pages.reports.schedule")}
              </th>
            </tr>
          </thead>
          <tbody>
            {room.rows.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: "center", padding: "8px" }}>
                  {t("pages.reports.noAssignmentsForThisSala")}
                </td>
              </tr>
            ) : (
              room.rows.map((row, index) => (
                <tr key={index}>
                  <td className={`${styles.tableNameData}`}>{row.mesa}</td>
                  <td className={`${styles.companyNameData}`}>
                    {row.companyName}
                  </td>
                  <td className={styles.spacesData}>{row.espacios}</td>
                  <td className={styles.scheduleData}>{row.horario}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoomAccomodationReportTable;
